import * as React from 'react'
import { cn } from '@/lib/utils'

export interface SectionHeaderProps {
    /** Main title text */
    title: string
    /** Optional description text below the title */
    description?: string
    /** Optional action element (button, link, etc.) aligned to the right */
    action?: React.ReactNode
    /** Additional class names */
    className?: string
}

/**
 * Consistent page/section headers with proper typography hierarchy.
 * Uses the serif display face (Lora) via the font-serif utility.
 */
export function SectionHeader({
    title,
    description,
    action,
    className,
}: SectionHeaderProps) {
    return (
        <div className={cn('flex items-start justify-between gap-4', className)}>
            <div className="space-y-1">
                <h1 className="font-serif text-2xl font-medium text-[var(--text-primary)]">
                    {title}
                </h1>
                {description && (
                    <p className="text-[var(--text-secondary)] text-sm max-w-2xl">
                        {description}
                    </p>
                )}
            </div>
            {action && (
                <div className="shrink-0">
                    {action}
                </div>
            )}
        </div>
    )
}
